import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AutService } from './auth/aut.service';
import { IUser } from './interfaces';
import { StorageService } from './services/storage.service';
import { RutasService } from './services/rutas.service';
import { FunctionsService } from './helpers/functions.service';
import { pages, dbLocalIndex } from './constants';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'Hacer Pedido',
      url: pages.home,
      icon: 'home-outline'
    },
    {
      title: 'Mis Ordenes',
      url: pages.myorders,
      icon: 'basket-outline'
    },
    // {
    //   title: 'Lista Deseos',
    //   url: pages.wishlist,
    //   icon: 'egg-outline'
    // },
    {
      title: 'Mi Perfil',
      url: pages.profile,
      icon: 'person-outline'
    },
    {
      title: 'Acerca de Bread Lab',
      url: pages.settings,
      icon: 'alert-circle-outline'
    },
    {
      title: 'Cerrar Sesión',
      url: pages.signout,
      icon: 'log-out-outline'
    }
  ];
  public nombreCliente = 'Invitado';

  constructor(
      private platform: Platform,
      private splashScreen: SplashScreen,
      private statusBar: StatusBar,
      private func: FunctionsService,
      private autService: AutService,
      private storageService: StorageService,
      private rutasService: RutasService
  ) {
    this.initializeApp();
    window.PixelPay = window.PixelPay || {};
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.rutasService.getRutas();
      this.presentacion().finally();
      // A-554: limpieza de datos de tarjeta cifrados con AES que versiones
      // anteriores dejaban en el Storage (el PAN ya no se persiste nunca)
      this.storageService.delete( dbLocalIndex.infoTC ).finally();
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }

    // Nos suscribimos al observer de la session del usuario
    this.autService.currentUser.subscribe( (data: IUser) => {
      if ( data ) {
        if (data.invitado) {
          this.appPages[ this.appPages.length - 1 ].title = 'Iniciar Sesión';
          this.appPages[ this.appPages.length - 1 ].url = pages.login;
          this.appPages[ this.appPages.length - 1 ].icon = 'log-in-outline';
        } else {
          this.appPages[ this.appPages.length - 1 ].title = 'Cerrar Sesión';
          this.appPages[ this.appPages.length - 1 ].url = pages.signout;
          this.appPages[ this.appPages.length - 1 ].icon = 'log-out-outline';
        }
        this.nombreCliente = data.nombre;
      }
    });
  }

  async presentacion() {
    // Verificamos si el usuario ya paso la parte de la presentación
    const onboard = await this.storageService.get( dbLocalIndex.presentacion );
    if ( !onboard ) {
      await this.func.setNavigation(pages.onboarding);
    }
  }
}
